let Templates = {};
Templates['Default'] = require('./Default/Default.js').default;
Templates['About'] = require('./About/About.js').default;
Templates['Treatment'] = require('./Treatment/Treatment.js').default;
Templates['Prices'] = require('./Prices/Prices.js').default;

export default Templates
